import {Injectable} from '@angular/core';
import {ConfigurationService} from '../configuration.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {StateManagerService} from '../state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';

@Injectable({
    providedIn: 'root'
})
export class UpdateTimeStampService {

    constructor(private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    generateTimeStamp(): string {
        const date = new Date();
        let milli: string;
        const year = '' + date.getFullYear();
        const month = (date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : '' + (date.getMonth() + 1);
        const day = (date.getDate()) <= 9 ? '0' + (date.getDate()) : '' + (date.getDate());
        const hour = (date.getHours()) <= 9 ? '0' + (date.getHours()) : '' + (date.getHours());
        const min = (date.getMinutes()) <= 9 ? '0' + (date.getMinutes()) : '' + (date.getMinutes());
        const sec = (date.getSeconds()) <= 9 ? '0' + (date.getSeconds()) : '' + (date.getSeconds());
        const milliRaw = date.getMilliseconds();
        if (milliRaw <= 9) {
            milli = '00' + milliRaw;
        } else if (milliRaw <= 99) {
            milli = '0' + milliRaw;
        } else {
            milli = '' + milliRaw;
        }
        return year + '-' + month + '-' + day + '-' + hour + '-' + min + '-' + sec + '-' + milli;
    }

    updateTimeStamp(parameter: string) {
        const config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        const currentTime = this.generateTimeStamp();
        Object.keys(config).forEach(function (key) {
            if (key === parameter) {
                config[key] = currentTime;
            }
        });
        this.stateManager.upsert(this.collectionNames.CONFIGURATION, '$loki', config);
    }

    resetTimeStamp() {
        const config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION) as ConfigurationModel;
        config.custDateTime = '1899-01-01-00-00-00-000';
        config.contactDateTime = '1899-01-01-00-00-00-000';
        config.equipmentDateTime = '1899-01-01-00-00-00-000';
        config.productDateTime = '1899-01-01-00-00-00-000';
        config.siteDateTime = '1899-01-01-00-00-00-000';
        config.contractDateTime = '1899-01-01-00-00-00-000';
        config.haccessDateTime = '1899-01-01-00-00-00-000';
        config.saccessDateTime = '1899-01-01-00-00-00-000';
        config.hratesDateTime = '1899-01-01-00-00-00-000';
        config.priceListDetailsDateTime = '1899-01-01-00-00-00-000';
        config.ptSerialDateTime = '1899-01-01-00-00-00-000';

        this.stateManager.upsert(this.collectionNames.CONFIGURATION, '$loki', config);
    }
}
